'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var CheckCircleIcon = _interopDefault(require('@material-ui/icons/CheckCircle'));
var WarningRoundedIcon = _interopDefault(require('@material-ui/icons/WarningRounded'));
var InfoIcon = _interopDefault(require('@material-ui/icons/Info'));
var styledComponents = require('./styled-components.js');
var DefaultAction = require('./components/DefaultAction/DefaultAction.js');

var iconMapping = {
    success: React__default.createElement(CheckCircleIcon, { fontSize: 'inherit' }),
    warning: React__default.createElement(WarningRoundedIcon, { fontSize: 'inherit' }),
    error: React__default.createElement(InfoIcon, { fontSize: 'inherit' }),
    info: React__default.createElement(InfoIcon, { fontSize: 'inherit' }),
};
var AlertBanner = function (props) {
    var _a = props.open, open = _a === void 0 ? true : _a, severity = props.severity, onClose = props.onClose, children = props.children, _b = props.withClose, withClose = _b === void 0 ? false : _b, actionOverrideElement = props.actionOverrideElement;
    var defaultAction = withClose && React__default.createElement(DefaultAction, { onClose: onClose });
    var action = actionOverrideElement ? (React__default.createElement(styledComponents.CustomActionContainer, { "data-testid": 'alert-banner-custom-action' }, actionOverrideElement)) : (defaultAction);
    return (React__default.createElement(core.Collapse, { in: open },
        React__default.createElement(styledComponents.StyledAlert, { severity: severity, iconMapping: iconMapping, action: action }, children)));
};

module.exports = AlertBanner;
